var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_14657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8895 2.11426C6.28115 2.11426 2.55615 5.83926 2.55615 10.4476C2.55615 15.0559 6.28115 18.7809 10.8895 18.7809C15.4978 18.7809 19.2228 15.0559 19.2228 10.4476C19.2228 5.83926 15.4978 2.11426 10.8895 2.11426ZM14.4728 14.0309C14.1478 14.3559 13.6228 14.3559 13.2978 14.0309L10.8895 11.6226L8.48115 14.0309C8.15615 14.3559 7.63115 14.3559 7.30615 14.0309C6.98115 13.7059 6.98115 13.1809 7.30615 12.8559L9.71449 10.4476L7.30615 8.03926C6.98115 7.71426 6.98115 7.18926 7.30615 6.86426C7.63115 6.53926 8.15615 6.53926 8.48115 6.86426L10.8895 9.27259L13.2978 6.86426C13.6228 6.53926 14.1478 6.53926 14.4728 6.86426C14.7978 7.18926 14.7978 7.71426 14.4728 8.03926L12.0645 10.4476L14.4728 12.8559C14.7895 13.1726 14.7895 13.7059 14.4728 14.0309Z",
    fill: "#EE5D50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_14657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.889648 0.447266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c4b68a10f15e814f7359b43f5e345de8.svg";
export { ForwardRef as ReactComponent };